import { Volume } from '~/shared/types/api';
import { toaster } from '~/shared/utils/toaster';
import { getApiFilters } from '~/shared/utils/apiFilters';
import { DatafySwitchContextType } from '~/shared/context/DatafySwitchProvider';
import {
  canBeDatafied,
  canBeUnDatafied,
  isSwitchedOn,
  isSwitchDisabled,
} from '~/shared/utils/volumeHelpers';

export const baseUrl = `/api/v1/volumes`;

export { canBeDatafied, canBeUnDatafied, isSwitchedOn, isSwitchDisabled };

export { getApiFilters as getApiFilterFromSelectOption };

export function datafyErrorToast(
  volumeId: Volume['volumeId'],
  event: DatafySwitchContextType['datafySwitchVolumes'][number]['state']
) {
  return toaster({
    variant: 'error',
    title: `${event === 'datafying' ? 'Datafication' : 'Undatafication'} Error`,
    message: `Volume ${volumeId} has failed to ${event === 'datafying' ? 'Datafy' : 'Undatafy'}.`,
    toastId: volumeId,
  });
}

export const optmisticSwitchingInterval = 20000;

export function getFilterSearchParams(
  filters: {
    field: 'monitoring' | 'sourceVolume' | 'volumeId' | 'instanceId' | 'diskType';
    value: string;
    op: 'equals';
  }[]
) {
  return [
    ...filters.map(({ field, value, op }) => ['filters', JSON.stringify({ field, value, op })]),
  ];
}

export const datafyDevelopmentTenantId = [
  '79c406c5-7b64-43f2-ba76-9b01e74e3d90',
  'c7503430-6ffd-4625-87a8-2acc7979e198',
];

export function shouldShowFullGraph(
  hasFullGraphParam: boolean,
  activeAccountId: string | undefined
): boolean {
  return (
    hasFullGraphParam ||
    (activeAccountId !== undefined && datafyDevelopmentTenantId.includes(activeAccountId))
  );
}
